export default "__VITE_ASSET__DGSrMYhA__"